<template>
  <input
    v-if="id == 'birth_date'"
    :value="value || ''"
    :id="`input-${id}`"
    v-mask="'##/##/####'"
    :ref="id"
    :type="type"
    :disabled="disabled"
    :placeholder="getReferencelabel(placeholder)"
    :class="{ 'red-border': valid }"
    :autocomplete="autocomplete"
    @input="$emit('update:value', $event.target.value)"
  />
  <input
    v-else
    :value="value || ''"
    :id="`input-${id}`"
    :ref="id"
    :type="type"
    @input="$emit('update:value', $event.target.value)"
    :disabled="disabled"
    :placeholder="getReferencelabel(placeholder)"
    :class="{ 'red-border': valid }"
    :autocomplete="autocomplete"
  />
</template>

<script setup>
import { getReferencelabel } from '@/mixins/utils';
import { defineEmits } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  value: {
    type: [String, null],
    default: '',
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  valid: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
  autocomplete: {
    type: String,
    default: 'on',
  },
});

const emit = defineEmits(['update:value']);
</script>
